import React from 'react';

import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import GetAppIcon from '@mui/icons-material/GetApp';

import { capitalize } from 'helpers/helpers';
import TooltipIconButton from 'components/TooltipIconButton';

import Alert from 'ui/Alert/Alert';

type FailedDataAlertProps = {
    action: () => void;
    setShow: (arg1: boolean) => void;
};

const StyFailedDataAlert = styled(Alert, {
    name: 'StyFailedDataAlert',
})({
    alignItems: 'center',
    mb: '1rem',
});

const FailedDataAlert = (props: FailedDataAlertProps): React.ReactElement => {
    const { t } = useTranslation();
    const { action, setShow } = props;
    return (
        <StyFailedDataAlert
            severity="warning"
            onClose={() => setShow(false)}
            action={
                <TooltipIconButton
                    tooltip={capitalize(t('common.download'))}
                    placement="bottom"
                    onClick={action}
                    icon={<GetAppIcon />}
                />
            }
        >
            {t('importCSV.error.failedData')}
        </StyFailedDataAlert>
    );
};

export default React.memo<FailedDataAlertProps>(FailedDataAlert);
